const Bits = (function () {
  'use strict';

  const MAX_NUMBER = 2147483647; // ~(1 << 31)
  const MIN_NUMBER = -2147483648; // (1 << 31)

  function bits_maxima(bits) {
    return (1 << bits) - 1;
  }

  function bits_size(a) {
    return (a >= MIN_NUMBER && a <= MAX_NUMBER)
      ? (a >= 0)
        ? Math.ceil(Math.log2(a + 1))
        : 31
      : null;
  }

  function bits_truncate(a, bits) {
    return bits ? a & bits_maxima(bits) : a;
  }

  function bits_clamp(a, bits) {
    return Math.min(a, bits_maxima(bits));
  }

  function bits_difference(a, b, bits) {
    return bits_truncate(a, bits) ^ bits_truncate(b, bits);
  }

  function bits_overflows(a, bits) {
    return a !== bits_truncate(a, bits);
  }

  return {
    MAX_NUMBER,
    MIN_NUMBER,
    clamp: bits_clamp,
    difference: bits_difference,
    maxima: bits_maxima,
    overflows: bits_overflows,
    size: bits_size,
    truncate: bits_truncate
  };
})();

export default Bits;
